import {
  Accent,
  MarketingSection,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";

const COPY = [
  "Lutely is not here to replace the major streaming platforms. Release your music wherever your audience listens, then give your most engaged fans a reason to come closer.",
  "Drive fans to Lutely for a richer experience built around ownership, alternate versions, and content that goes beyond the standard stream. Some artists may choose to release exclusively on Lutely, but you do not have to.",
];

export default function SellStrategy() {
  return (
    <MarketingSection
      className="bg-marketing-navy"
      innerClassName="grid grid-cols-[1.05fr_0.95fr] items-center gap-[86px] max-[980px]:grid-cols-1 max-[680px]:gap-[42px]"
    >
      <div>
        <SectionKicker className="!text-teal-500">
          Part of your release strategy
        </SectionKicker>
        <SectionTitle className="text-white">
          Use streaming for reach.
          <br />
          <Accent>Use Lutely to go deeper.</Accent>
        </SectionTitle>
      </div>
      <div>
        {COPY.map((text) => (
          <p
            key={text}
            className="mb-[22px] font-open-sans text-[18px] leading-[1.7] text-white/[0.74]"
          >
            {text}
          </p>
        ))}
      </div>
    </MarketingSection>
  );
}
